import styled from '@emotion/styled';

export const SadaDocumentsSection = styled.div`
  input {
    display: none;
  }
`;
